import * as dotenv from "dotenv";
dotenv.config();

window.onload = () => {
  if (/ilmoittaudu/.test(location.href)) {
    window.location.href = "https://forms.gle/gRhVhneF7WWiwBXK6";
  }
};
